import React from 'react'
import NotificationBar from '../../NotificationBar'
import {connect} from 'react-redux'
import {notificationReset} from '../../actions/notification/notification'
import ProgressBar from '../../frags/ProgressBar'

class AppContainer extends React.Component {
  render () {
    const {notifications} = this.props
    return <div>
      <ProgressBar
        updateTime={500}
        currentPath='/' // TODO FIXME give proper current URL
      />
      {notifications.map((notif, idx) => {
        return <NotificationBar
          message={notif.message}
          type={notif.type}
          afterFadeout={this.props.resetNotif}
          key={idx}
        />
      })}
      {this.props.children}
    </div>
  }
}

function mapStateToProps (state) {
  return {
    notifications: state.notification.alerts,
    loading: state.notification.loading
  }
}

function mapDispatchToProps (dispatch) {
  return {
    resetNotif: () => {
      dispatch(notificationReset({}))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)



// WEBPACK FOOTER //
// app/javascript/components/frags/AppContainer/AppContainer.js